<template>
  <div class="p-8">
    <div class="flex justify-between w-full">
      <h1 class="text-2xl font-medium">คำแนะนำสุขภาพ</h1>
      <router-link :to="{ name: 'admin-health-recommendation-create' }">
        <button class="button-solid bg-primary block mx-0 text-white px-6 py-1">สร้างคำแนะนำใหม่</button>
      </router-link>
    </div>
    <a-table class="mt-12" :columns="columns" :data-source="data">
      <template slot="action" slot-scope="eLearning">
        <router-link
          :to="{
            name: 'admin-e-learning-edit',
            params: { eLearningId: eLearning.id },
          }"
        >
          <a-button icon="edit" />
        </router-link>

        <a-button @click="showDeleteModal(eLearning.id)" class="ml-2" icon="delete" />
      </template>
    </a-table>
  </div>
</template>
<script>
import axios from "axios";

const columns = [
  {
    title: "หัวข้อ",
    dataIndex: "title",
    key: "name",
    sorter: true,
  },
  {
    title: "วันที่ส่ง",
    dataIndex: "created_at",
    key: "created_at",
    sorter: true,
  },
];

export default {
  created() {
    this.fetchELearnings();
  },
  data() {
    return {
      data: null,
      columns,
    };
  },
  methods: {
    showDeleteModal(eLearningId) {
      this.$confirm({
        title: "ยืนยันการลบบทเรียน E-Elearning",
        content: "การลบบทเรียนจะไม่สามารถกู้คืนได้",
        okText: "ลบ",
        okType: "danger",
        cancelText: "ยกเลิก",
        onOk: async () => {
          try {
            const response = await axios.delete(`api/e-learning/${eLearningId}`);

            this.fetchELearnings();
          } catch (error) {
            console.log(error);
          }
        },
        onCancel() {},
      });
    },
    async fetchELearnings() {
      let loader = this.$loading.show();

      try {
        const response = await axios({
          method: "GET",
          url: `${process.env.VUE_APP_API_URL}/health-recommendation`,
          headers: { authorization: `Bearer ${localStorage.getItem("TOKEN")}` },
        });

        this.data = response.data;

        loader.hide();
      } catch (error) {
        loader.hide();

        console.log(error);
      }
    },
  },
};
</script>
